import { useNavigate } from 'react-router-dom';
import { useCallback } from 'react';
import type { NotificationTarget } from '../types';

export function useNotificationNavigation() {
  const navigate = useNavigate();

  return useCallback(
    (target: NotificationTarget) => {
      switch (target.entity) {
        case 'update':
          void navigate(`/updates`);
          break;
        case 'download':
          void navigate(`/updates`);
          break;
        case 'transfer':
          void navigate(`/transfers`);
          break;
        case 'order':
          void navigate(`/orders/${target.id}`);
          break;
      }
    },
    [navigate],
  );
}
